(function () {
  function rebuildCartDrawer() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  function initClearCart() {
    var btn = document.querySelector('[data-valor-clear-cart]');
    if (!btn || btn.dataset.valorBound === 'true') return;
    btn.dataset.valorBound = 'true';

    btn.addEventListener('click', function () {
      if (!window.confirm('Remove all items from your bag?')) return;

      btn.disabled = true;
      btn.classList.add('is-loading');

      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart: cart },
            })
          );
          rebuildCartDrawer();
        })
        .catch(function () {
          window.alert('Could not clear your bag. Please try again.');
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClearCart);
  } else {
    initClearCart();
  }
  document.addEventListener('shopify:section:load', initClearCart);
})();
